module.exports = __webpack_public_path__ + "img/noSearch.b7857c2b.png";